import { render, staticRenderFns } from "./rodape.vue?vue&type=template&id=96c7c99e&scoped=true"
import script from "./rodape.vue?vue&type=script&lang=js"
export * from "./rodape.vue?vue&type=script&lang=js"
import style0 from "./rodape.vue?vue&type=style&index=0&id=96c7c99e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c7c99e",
  null
  
)

export default component.exports